// src/pages/NewsArticle.jsx

import React, { useState } from "react";
import { useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { useData } from "../context/DataProvider";

const NewsArticle = () => {
   const { id } = useParams();
   const { articles, loading } = useData();

   // Локальное состояние для показа “toast”
   const [showToast, setShowToast] = useState(false);

   if (loading) {
      return <div className="p-8">Загрузка данных из Google Sheets...</div>;
   }

   const article = articles.find((item) => item.ID === id);

   if (!article) {
      return (
         <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
            <h1 className="text-2xl font-bold mb-4">Статья не найдена</h1>
            <p>Возможно, вы перешли по неверной ссылке.</p>
         </div>
      );
   }

   const { Title, Category, Date, ImageUrl, Author, ["Content (Markdown)"]: content } = article;

   // Копирование ссылки в буфер обмена
   const handleShare = () => {
      const currentUrl = window.location.href;
      navigator.clipboard
         .writeText(currentUrl)
         .then(() => {
            // Показываем тост на 2 секунды
            setShowToast(true);
            setTimeout(() => {
               setShowToast(false);
            }, 2000);
         })
         .catch((err) => {
            console.error("Clipboard copy failed", err);
         });
   };

   return (
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
         {/* Хероблок */}
         <div className="mb-6">
            <div className="relative">
               <img
                  src={ImageUrl || "https://via.placeholder.com/1200x600"}
                  alt="Основное изображение статьи"
                  className="w-full h-auto object-cover rounded-lg shadow"
               />
            </div>
         </div>

         {/* Метаданные */}
         <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between mb-4">
            <div className="flex flex-wrap items-center gap-2 text-sm text-gray-500">
               <span className="bg-gray-200 text-gray-700 px-2 py-1 rounded">{Category}</span>
               <span>{Date}</span>
               <span>Автор: {Author}</span>
            </div>
            {/* Кнопки (Поделиться, Сохранить) */}
            <div className="mt-2 sm:mt-0">
               <button onClick={handleShare} className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded text-sm mr-2">
                  Поделиться
               </button>
               <button className="bg-gray-100 hover:bg-gray-200 text-gray-800 px-3 py-1 rounded text-sm">Сохранить</button>
            </div>
         </div>

         {/* Основной контент */}
         <div className="prose max-w-none mb-8 text-gray-800">
            <ReactMarkdown remarkPlugins={[remarkGfm]}>{content}</ReactMarkdown>
         </div>

         {/* Теги */}
         <div className="flex flex-wrap items-center gap-2 mb-8">
            <span className="bg-gray-200 text-gray-700 px-2 py-1 rounded text-sm">#{Category}</span>
            <span className="bg-gray-200 text-gray-700 px-2 py-1 rounded text-sm">#АманкелдіАрайы</span>
         </div>

         {/* Красивый Toast, показывается если showToast === true */}
         {showToast && (
            <div
               className="fixed top-4 right-4 bg-green-600 text-white px-4 py-2 rounded shadow 
                       transition-transform transform-gpu
                       animate-fade-in-down z-50"
            >
               Сілтеме көшірілді!
            </div>
         )}
      </div>
   );
};

export default NewsArticle;
